<template>
    <div id="telematicsReadingList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Unit Reading List</div>
                    <div class="web-action-btn">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal" >
                                <i class="fp-import"></i> Import
                            </a>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                                <i class="fp-export"></i> Export
                            </a>
                            <router-link v-bind:to="'/report/emails'" class="btn btn-secondary" >
                                <i class="fp-reports"></i> Emails Report
                            </router-link>
                        </div>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li> <a href="javascript:void(0)" v-on:click="openModal"> Import </a> </li>
                                <li><a href="javascript:void(0)" class="" v-on:click="exportReports()">Export</a></li>
                                <li> <router-link v-bind:to="'/report/emails'" class="" >Emails Report</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content unit-reading-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'customerUnitReadingList'" ref="filterReadingList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'customerUnitReadingList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="readingList"
                                    mode="remote"
                                    title="Odometer Reading"
                                    @on-row-click="onRowClick"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    @on-select-all="onSelectAll"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        setCurrentPage:listCurrentPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: readingNotification,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"

                                    :search-options="{
                                        enabled: false,
                                    }">
                                     <div slot="selected-row-actions">
                                        <button v-if="canSendReadingNotification" id="send" v-on:click.prevent="performTask('notification')" class="btn btn-primary">Send Notification</button>
                                        <button id="deletBtn" v-on:click.prevent="performTask('delete')" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade invoice-modal update-reading-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Select File</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form id="importFile" class="addinspectionForm basic-form-container">
                                                    <div class="form-row">
                                                        <div class="col">
                                                            <label class="control-label require" for="name">File:</label>
                                                            <input id="typeImage" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.template, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, application/vnd.ms-excel.addin.macroEnabled.12, application/vnd.ms-excel.sheet.binary.macroEnabled.12" @change="onFileChanged">
                                                            <span class="field-error">{{error}}</span>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div>
                                                    <template v-if="dateEmpty != ''">
                                                        <p class="field-error">{{dateEmpty}}</p>
                                                    </template>
                                                    <template v-if="reminddateEmpty != ''">
                                                        <p class="field-error">{{reminddateEmpty}}</p>
                                                    </template>
                                                    <template v-if="readingdateEmpty != ''">
                                                        <p class="field-error">{{readingdateEmpty}}</p>
                                                    </template>
                                                    <template v-if="notFoundArr.length > 0">
                                                        <p class="field-error">{{notValid}}:</p>
                                                        <p>&nbsp;</p>
                                                        <template v-for="(unit ,key) in notFoundArr">
                                                            <!-- {{notFoundArr.length}}---{{key}} -->
                                                            <span :key="key"> {{unit}}<a v-if="key < notFoundArr.length - 1">,</a></span>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                            <div class="modal-footer btm-action-btn-fl">
                                                <button type="button" v-if="!notfound" class="btn btn-primary" id="myButton" v-on:click="importReport()">
                                                    <i class="fp-import"></i> {{ importBtnText }}
                                                </button>
                                                <button v-else type="button" class="btn btn-tertiary" v-on:click="loadList()" data-dismiss="modal">
                                                    <i class="fp-close"> </i> Cancel
                                                </button>
                                                <button v-if="!notfound" type="button" class="btn btn-tertiary" data-dismiss="modal">
                                                    <i class="fp-close"></i> Cancel
                                                </button>
                                                <button v-else class="btn btn-primary" id="okbutton" v-on:click="loadList()" data-dismiss="modal">OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>

</template>
<script>

import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "readingList",
        metaInfo() {
            return {
                title: "Unit Reading List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetReadingVal: {
                type: String,
                required: false,
                default: undefined
            }
        },

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            selectedFile:"",
            deviceType:"",
            error:"",
            notfound:false,
            notFoundArr:[],
            unitNum:"",
            reading:"",
            section:"",
            id:0,
            userColumns:[],
            columns: [
                {
                    label: '#Customer',
                    field: 'customer_number',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "$Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'customer_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit No.',
                    field: 'unitNo',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    html:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Notify Times',
                    field: 'notify_times',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Notified", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Responded',
                    field: 'is_customer_responded',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Responded", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Response Type',
                    field: 'response_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Response Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reminder Date',
                    field: 'reminder_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sent Date',
                    field: 'sent_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'email_status',
                    fpFieldType:"option",
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Queued', 'Sent','Opened','Failed'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sent By',
                    field: 'sent_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sent By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            customer_value: false,
            loading:false,
            fromDate:"",
            readingError:"",
            unit:"",
            readingDate:"",
            readingNotification:true,
            reqeustSent:0,
            //flagType:"",
            notValid:'',
            action:'list',
            flag:'list',
            reminddateEmpty:'',
            readingdateEmpty:'',
            dateEmpty:'',
            canSendReadingNotification:false,
            importBtnText:"Import",
            pageKey:"_notice_list_",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'odometer_reading_report') {
                            self.cantAccessPage = true;
                            self.readingNotification = true;
                        }
                        if (permissions[i].name == 'send_odometer_reading_notification') {
                            self.canSendReadingNotification = true;
                        }
                    }
                }

            }

        },
        created: function() {
            this.serverParams.sort = {field:"id",type:"desc"};
        },

        mounted: function() {
            var self = this;

            this.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.readingList.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                var rowData = self.$refs['readingList'].selectedRows;
                console.log(rowData);
            },

            exportReports: function() {
                var self = this;
                this.flag = "export";
                this.loadList();
            },

            loadList() {

                //remove row of details if any open
                $('table tr.invoiceDetails').remove();

                var self = this;
                var data = this.$refs['readingList'].selectedRows;
                var selectedCust = [];

                for (var i = 0; i < data.length; i++) {
                    selectedCust.push(self.$refs['readingList'].selectedRows[i].id)
                }

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    asset_id: self.assetId,
                    all:self.serverParams.selectedAll,
                    id:selectedCust,
                    //action:self.action,
                };
                self.firstLoad = 1;
                var notificationflage=self.flag;
                $.ajax({
                    url: process.env.ROOT_API + "/pending_reading/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;

                        console.log(data);
                        if ( data.status == "success" ) {

                            if ( self.flag == "notification" || self.flag == "delete" ) {

                                self.flag = "list";
                                self.$refs.filterReadingList.clearSelectAll();

                                if (notificationflage == "notification" ) {
                                    self.$swal('','Notices have been sent to the customer successfully.','success');
                                } else {
                                    self.$swal('','Notices have been deleted successfully','success');
                                }
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                                //EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                                return;
                            }

                            if ( self.flag == 'export' ) {

                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);
                                    self.$refs.readingList.unselectAllInternal();
                                    EventBus.$emit('clear-all-flags', false);
                                }


                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }

                        }
                        self.flag = 'list';
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.flag == "notification" || self.flag == "delete") {
                            self.generateStatusCodeMessage(jqXHR,true,'reading-list-delete');
                        }else if (self.flag == "export") {
                            self.generateStatusCodeMessage(jqXHR,true,'reading-list-export');
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'unit-reading-list');
                        }
                        self.flag = 'list';
                    }
                });
            },
             onFileChanged (event) {
                const file = event.target.files[0]
                console.log(event.target);
                var self = this;
                var type = file.type;
                console.log("file = ", type);
                if(type === 'application/vnd.ms-excel'
                || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
                || type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || type === 'application/vnd.ms-excel.template.macroEnabled.12'
                || type === 'application/vnd.ms-excel.addin.macroEnabled.12' || type === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') {
                  self.error = "";
                  self.selectedFile = file;
                  self.notfound = false;
                  self.notFoundArr = [];
                  console.log(self.selectedFile);
                } else {
                  var extention = file.name.split('.').pop();
                  self.error = extention + " is not supporter file type, please select excel";
                }


            },
            openModal: function(){
                var self = this;
                self.error = "";
                self.importBtnText = "Import";
                //$('#myButton').text('Import');
                self.notFoundArr = [];
                self.selectedFile = "";
                self.notfound = false;
                $("#typeImage").val('');
                $('#myModal').modal('show');
            },
            importReport: function(){
                var self = this;
                if(self.selectedFile == "" || self.selectedFile == null){
                    self.error = "Please Select Excel File.";
                    return;
                }else{
                    self.error = "";
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                // formData.append('device', self.deviceType);

                self.loading = true;
                self.importBtnText = "Fetching...";
                //$('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                url: process.env.ROOT_API + "/reading/import_data",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.importBtnText = "Import";
                    //$('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                    self.loading = false;
                    if(data.code == 201){
                        if(data.invalidEmail.length > 0){
                            self.notfound = true;
                            self.notValid = data.failed;
                            if ( data.date_error){

                                self.dateEmpty = data.date_error;

                            }
                            if ( data.remind_date_error){

                                self.reminddateEmpty = data.remind_date_error;

                            }
                            if ( data.reading_date_error){

                                self.readingdateEmpty = data.reading_date_error;

                            }
                            self.importBtnText = "OK";
                            //$('#myButton').text('OK');
                            self.notFoundArr = data.invalidEmail;
                        }else{
                            self.error = data.message;
                        }

                        return;
                    }
                    if (data.status == "success") {
                        self.error = "";
                        if(data.invalidEmail.length > 0){
                            self.notfound = true;
                            self.notValid = data.failed;
                            self.importBtnText = "OK";
                            //$('#myButton').text('OK');
                            self.notFoundArr = data.invalidEmail;
                        }else if ( data.remind_date_error){

                            self.reminddateEmpty = data.remind_date_error;

                        }else if ( data.reading_date_error){

                            self.readingdateEmpty = data.reading_date_error;

                        }else if ( data.date_error){

                            self.dateEmpty = data.date_error;

                        }else{
                            $('#myModal').modal('hide');
                            self.loadList();
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.importBtnText = "Import";
                    //$('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                   self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'reading-list-import');
                }
            });
            },

            performTask: function(flag) {
                var message = "Are you sure you want to perform this action?";
                if (flag == "delete") {
                  var self = this;
                  self.$swal({
                      title: 'Are you sure that you want to delete this Unit Reading?',
                      type: 'info',
                      showCancelButton: true,
                      confirmButtonText: 'Yes',
                      cancelButtonText: 'No',
                      showCloseButton: false,
                      showLoaderOnConfirm: true
                  }).then((result) => {
                      if (result.value) {
                        self.flag = flag;
                        self.loadList();
                    } else {
                      console.log("no");
                    }
                });
                    //message = "Are you sure you want to delete this Unit Reading?";
                }else{
                    message = "Are you sure you want to send Notification to Customer?";

                      if ( confirm(message) ) {
                          var self = this;
                          //self.action = 'notification';
                          self.flag = flag;
                          self.loadList();
                      }
                }

            },

            onRowClick(params) {

                var self = this;


                if ( $(params.event.target).hasClass("vgt-checkbox-col") || $(params.event.target).hasClass("glyphicon glyphicon-eye-open")) {
                   return;
                }

                if ( self.reqeustSent == 1 ) {
                   return;
                }

                //if data already available than remove it
                if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("invoiceDetails")) {
                    $(params.event.target.closest('.clickable').nextSibling).remove();
                    return;
                }

                //generate html
                var html = '<tr class="invoiceDetails"><td colspan="12"><table aria-describedby="table" class="table">';
                    html += '<tr><th>Unit No.</th><th>Mileage</th><th>Reefer Stand By</th><th>Reefer Hours</th><th>Engine Hours</th><th>APU</th><th>Reading Date</th><th>Updated At</th><th>Added By</th><th>Added By Name</th></tr>';

                var fields = {
                            readingReminderId:params.row.id,
                        };
                self.reqeustSent = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/unit-reading/details",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.reqeustSent = 0;
                        self.loading = false;
                        if ( data.code == 200 ) {

                            //check data records
                            if ( data.content.length > 0 ) {

                                for ( var j=0; j<data.content.length; j++ ) {
                                    html += '<tr><td>'+data.content[j].unitNo+'</td><td>'+data.content[j].mileage+'</td><td>'+data.content[j].reeferStandBy+'</td><td>'+data.content[j].reeferHours+'</td><td>'+data.content[j].engineHours+'</td><td>'+data.content[j].apu+'</td><td>' +data.content[j].readingDate+'</td><td>' +data.content[j].updatedAt+'</td><td>' +data.content[j].added_by+'</td><td>' +data.content[j].added_by_name+'</td></tr>';
                                }

                            } else {
                                html += '<tr><td colspan="4">No record found.</td></tr>';
                            }

                            html += '</table></td></tr>';
                            $(html).insertAfter(params.event.target.closest('.clickable'));

                        }
                    },
                    error: function (jqXHR, exception) {

                        self.reqeustSent = 0;

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'reading-details');
                    }
                });
            },

        }
    };
</script>

<style scope>
/* #telematicsReadingList .vgt-wrap {
    float: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/telematicsReading/ReadingNotificationList.vue